<template>
  <svg
    :class="classes"
    :style="{cursor: cursor}"
    @click="handleClick">
    <title v-if="title" v-text="title"></title>
    <use :xlink:href="iconPath"></use>
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    type: {
      type: String,
      default: 'grey'
    },
    title: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    cursor: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      const prefixCls = 'i-icon' 
    
      return [
        prefixCls,
        `${prefixCls}-${this.name}`,
        {
          [`${prefixCls}__${this.type}`]: !!this.type
        }
      ]
    },
    iconPath() {
      return this.path ? `#icon-${this.path}-${this.name}` : null
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @icon-type: primary, secondary, info, warning, error;
  .icon-type-loop(@i: 1, @val: extract(@icon-type, @i)) when (@i < length(@icon-type) + 1) {
    .i-icon {
      &&__@{val} {
        color: @@val;
      }
    }

    .icon-type-loop(@i + 1);
  }
  .icon-type-loop(1);

  .i-icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    border: none;
    outline: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    &&__grey {
      color: var(--icon-color, @grey-600);
    }
    &&-spinner {
      animation: loading 2s linear infinite;
    }
  }
</style>